import React from 'react';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { EtatFormField, EtatFormValue } from '../types';
import { buildDto } from '../utils';

import ModalEdition from './ModalEdition';

interface ModalCreateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalCreate({
  close,
  visible,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: EtatFormValue = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: EtatFormValue) =>
      AdminFonctionnelControllerApi.createEtatUsingPOST(buildDto(values)),
  );
  const { validate } = useValidateReferentielForm(
    (field: EtatFormField, values: EtatFormValue) =>
      AdminFonctionnelControllerApi.validateCreateEtatFieldUsingPOST(
        field,
        buildDto(values),
      ),
    response => response.etatViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Créer un état"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
